import { ChangeDetectorRef, Injectable, } from '@angular/core';
import { OpenwinServicePkg } from './openwinPkg.service';
import { Openwin } from '../entity/Openwin-angular';
import { AgTextAreaEditor, CR, jkBaseForm, jkGlb, jkLib } from 'jk-service';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OpenwinService extends OpenwinServicePkg {
  isPvi = false;
  constructor() {
    super();
    this.requiredFields = ['MainTable', 'ITEM', 'TYPE', 'Display', 'MAP', 'SQLSelect', 'SQLWhere'];

    this.columnDefs = [
      { field: "Title", headerName: "標題", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "PS", headerName: "備註", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "MainTable", headerName: "主資料表", headerTooltip: "", width: 100, cellDataType: "text", },
      { field: "ITEM", headerName: "序號", headerTooltip: "", width: 80, cellDataType: "text", },
      //{ field: "TYPE", headerName: "類別",headerTooltip: "",width:80,cellDataType: "text", },
      { field: "Display", headerName: "顯示", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "SQLOrder", headerName: "欄位排序", headerTooltip: "ORDER BY 欄位1 ASC/DESC,欄位2 ASC/DESC,...;中文顯示名稱", width: 250, cellDataType: "text", },
      //{ field: "CreateUserID", headerName: "建檔者", headerTooltip: "", width: 100, cellDataType: "text", },
      { field: "CreateDate", headerName: "建立日期", headerTooltip: "", width: 120, cellDataType: "date", valueFormatter: (p: any) => { return jkLib.datetimeFormatter(p.value) }, },
      { field: "ModiDate", headerName: "修改日期", headerTooltip: "", width: 120, cellDataType: "date", valueFormatter: (p: any) => { return jkLib.datetimeFormatter(p.value) }, },
      { field: "SQLSelect", headerName: "SQLSelect", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "SQLWhere", headerName: "SQLWhere", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "MAP", headerName: "WHERE參數設定", headerTooltip: "", width: 250, cellDataType: "text", },
      //{ field: "SQLReturn", headerName: "SQLReturn",headerTooltip: "",width:250,cellDataType: "text", },
    ];
    if (this.dbname === 'Y_RELEASED' || this.dbname === 'V_RELEASED') {
      this.isPvi = true;
      console.log('isPvi', this.isPvi);
    } else {
      this.isPvi = false;
    }
    if (this.isPvi) { // jkGlb.env.appId.toUpperCase() === 'PVI'
      this.sqlWhereDefault = `/*WHERE*/ WHERE TYPE='U' AND MainTable = 'PVI' `;
    } else
      this.sqlWhereDefault = `/*WHERE*/ WHERE TYPE='U' `;
  }

override async newRecord(newItem: Openwin): Promise<Openwin> {
    await super.newRecord(newItem);
    newItem.TYPE = 'U';
    newItem.CreateUserID = ''; // this.login.uid; 改為權限設定
    newItem.CreateDate = new Date();
    newItem.ModiDate = new Date();
    newItem.SQLSelect = `SELECT TOP 500
      FROM
      /*WHERE*/ WHERE 1=1`;
    newItem.SQLWhere = '/*WHERE*/ WHERE 1=1';
    newItem.SQLReturn = '';
    if (this.isPvi) { // this.login.customid === 'PVI'
      newItem.MainTable = 'PVI';
      newItem.SQLSelect = `SELECT TOP 500 TC001,TC002,TC003,TC004,MA002,TC012
      FROM COPTC
      LEFT JOIN COPMA ON MA001=TC004
      /*WHERE*/ WHERE 1=1
      /*ORDER*/ ORDER BY TC001,TC002`;
    } else {
      newItem.MainTable = this.login.customid;
    }

    newItem.ITEM = await this.geneItemNo(newItem.MainTable);
    return newItem;
  }

  override init() {
    super.init();
    this.sqlWhere = ` AND 1=1 `;

  }
  checkSqlWhereParam(sqlSelect: string): boolean {
    let boolean = true;
    let sql = sqlSelect.toUpperCase();
    let idx = sql.indexOf('/*WHERE*/');
    if (idx > 0) {
      let whereSql = sql.substring(idx + '/*WHERE*/'.length);
      if (whereSql.indexOf(':') > 0) {
        boolean = false;
      }
    }
    return boolean;

  }
  async setDisplay(sqlSelect: string, item: Openwin, cdr?: ChangeDetectorRef) {
    if (!this.checkSqlWhereParam(sqlSelect)) {
      alert('/*WHERE*/ 不要有參數(: 冒號)');
      return;
    }
    document.body.style.cursor = 'wait';
    const url = `${this.host}/db/setdisplay`;
    let body = { sqlSelect: sqlSelect };
    let method = 'post';
    //let ret:jkRestReturnClass = new jkRestReturnClass();
    try {
      let config = jkLib.axiosConfigInit(this.host, '/db/setdisplay', method, [], body);
      await jkLib.doAxios(config, this.ret);
      if (!this.ret.result) {
        const msg = 'setDisplay error: ' + this.ret.errorLog + CR + this.ret.obj.errorLog;
        console.error(msg);
        alert(msg);
        document.body.style.cursor = 'default';
        return;
      }
      // Update the value and trigger change detection in the next tick
      Promise.resolve().then(() => {
        item.Display = this.ret.obj.data;
        const changeDetector = cdr || this.cdr;
        if (changeDetector) {
          changeDetector.detectChanges();
        }
        document.body.style.cursor = 'default';
      });
    } catch (error: any) {
      document.body.style.cursor = 'default';
      const msg = 'setDisplay error: ' + error.message;
      console.error(msg);
      alert(msg);
      return;
    }
  }
  setDisplay2(sqlSelect: string, item: Openwin): Observable<any> {
    document.body.style.cursor = 'wait';
    const url = `${this.host}/db/setdisplay`;

    return this.orm.http.post(url, { sqlSelect: sqlSelect });
    /*.subscribe((res: any) => {
      console.log(res.obj);
      setTimeout(() => {
        item.Display = res.obj.data;
        //alert(res.obj.data);
        // Trigger change detection to avoid ExpressionChangedAfterItHasBeenCheckedError
        this.cdr.detectChanges();
        document.body.style.cursor = 'default';
      }, 5);
    });*/
  }
  async geneItemNo(mainTable: string): Promise<string> {
    const url = `${this.host}/db/geneItemNo?mainTable=${encodeURIComponent(mainTable)}`;
    const res: any = await firstValueFrom(this.orm.http.get(url));
    return res.obj.data;
  }

}
